module.exports = __webpack_public_path__ + "media/images/video-solid-8a94663095555f05d7b27612fbf4dc22.svg";